import React, { useState, useEffect } from 'react';
import './newCustomerDialog.css'; // Import CSS for styling the dialog
import { Url } from './url'; // Import the Url component
import { UrlDev } from './url'; // Import the Url component
import { getCookie } from './utils/cookies';
import { authFetchRequest } from './utils/api';
import { alertC } from './components/dialogService';



const savedCustomers = ['John Doe', 'Jane Smith', 'Company XYZ']; // Example saved customers

const NewCustomerDialog = ({ show, onClose, onCustomerAdded, overrideUserId = null }) => {
    const [customer, setCustomer] = useState({
        name: '',
        email: '',
        phone: '',
        discount: '',
        products: '',
        netTerms: '',
        fullName: '',
        mobilePhone: '',
        address1: '',
        address2: '',
        city: '',
        province: '',
        country: '',
        postalCode: '',
        fkUserId: '',
    });

  
    useEffect(() => {
        const fkUserId = overrideUserId ? parseInt(overrideUserId, 10) : parseInt(getCookie("user_id"), 10);
        if (isNaN(fkUserId)) {
        alert("User ID is invalid!");
        return;
        }
        setCustomer(prev => ({ ...prev, fkUserId }));
    }, [overrideUserId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name !== 'fkUserId') { // Prevent modification of fkUserId
            setCustomer({ ...customer, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const fkUserId = overrideUserId ? parseInt(overrideUserId, 10) : parseInt(getCookie("user_id"), 10);
        if (isNaN(fkUserId)) {
        await alertC("User ID is invalid!");
        return;
        }

        const payload = { ...customer, fkUserId };

        const response = await authFetchRequest(
        `/customers/`,
        payload,
        "POST",
        { Authorization: `Bearer ${getCookie("access_token")}` }
        );

        if (onCustomerAdded) {
            onCustomerAdded(response); // pass new customer back
        }

        onClose();
    } catch (err) {
        console.error("Failed to add customer:", err);
        await alertC("Failed to add customer: " + err.message);
    }
    };



    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>New Customer</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group-dialog">
                        <input type="text" name="name" value={customer.name} onChange={handleInputChange} placeholder="Customer Name" list="savedCustomers" required />
                        <datalist id="savedCustomers">
                            {savedCustomers.map((customer, index) => (
                                <option key={index} value={customer} />
                            ))}
                        </datalist>
                    </div>
                    <div className="form-group-dialog">
                        <input type="email" name="email" value={customer.email} onChange={handleInputChange} placeholder="Email" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="tel" name="phone" value={customer.phone} onChange={handleInputChange} placeholder="Phone" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="discount" value={customer.discount} onChange={handleInputChange} placeholder="Discount" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="products" value={customer.products} onChange={handleInputChange} placeholder="Selectable Products (Optional)" />
                    </div>
                    <div className="form-group-dialog">
                        <input type="text" name="netTerms" value={customer.netTerms} onChange={handleInputChange} placeholder="NET Terms" />
                    </div>
                    <div className="customer-details">
                        <h3>Customer Details</h3>
                        <input type="text" name="fullName" value={customer.fullName} onChange={handleInputChange} placeholder="Full Name" />
                        <input type="email" name="email" value={customer.email} onChange={handleInputChange} placeholder="Email" />
                        <input type="tel" name="phone" value={customer.phone} onChange={handleInputChange} placeholder="Phone" />
                        <input type="tel" name="mobilePhone" value={customer.mobilePhone} onChange={handleInputChange} placeholder="Mobile Phone" />
                    </div>
                    <div className="customer-address">
                        <h3>Customer Address</h3>
                        <input type="text" name="address1" value={customer.address1} onChange={handleInputChange} placeholder="Address 1" />
                        <input type="text" name="address2" value={customer.address2} onChange={handleInputChange} placeholder="Address 2" />
                        <input type="text" name="city" value={customer.city} onChange={handleInputChange} placeholder="City" />
                        <input type="text" name="province" value={customer.province} onChange={handleInputChange} placeholder="Province" />
                        <input type="text" name="country" value={customer.country} onChange={handleInputChange} placeholder="Country" />
                        <input type="text" name="postalCode" value={customer.postalCode} onChange={handleInputChange} placeholder="Postal Code" />
                    </div>
                    <div className="form-actions">
                        <button type="button" onClick={onClose}>Close</button>
                        <button type="submit">Add New</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewCustomerDialog;
